$(document).on('click', '._js-clear-notifications', function () {
  let notificationType = $(this).data('notification-type');
  let notificationEntity = $(this).data('notification-entity');
  $(this).siblings('.notification-wrapper').hide();
  clearNotifications(notificationType, notificationEntity);
  if ($(this).hasClass('_js-clear-all-exam-notify')) {
    $(".aside-navigation__link[href='/personal/exams/']").siblings('.aside-navigation__notifications').hide();
  }
});

$(document).ready(function() {
  let $firstTabLink = $('.tabs-list__link').first();
  if ($firstTabLink.hasClass('_js-clear-notifications')) {
    let notificationType = $firstTabLink.data('notification-type');
    let notificationEntity = $firstTabLink.data('notification-entity');
    clearNotifications(notificationType, notificationEntity);
  }
});

function clearNotifications(type, entity) {
  let data = {type: type};
  if (typeof entity !== 'undefined') {
    data.entity = entity;
  }
  BX.ajax({
    url: '/local/ajax/removeNotifications.php',
    method: 'POST',
    data: data,
    dataType: 'json',
    onsuccess: function(result) {
      if (result.error) {

      } else {

      }
    }
  });
}
